import axios, { getData } from "lib/axios";


//fetching parameters of specific single form
export const getForm = (formId) => {
  return axios
    .get(`/forms/${formId}`)
    .then(getData);
};

export const getAllForm = () => {
  return axios
    .get("/forms")
    .then(getData)
}

export const createForm = (data) => {
  return axios
    .post("/admin/forms", data)
    .then(getData)
}

export const saveForm = (formId, data) => {
  return axios
    .put(`/admin/form-save/${formId}`, data)
    .then(getData)
}

export const deleteForm = (formId) => {
  return axios
    .delete(`/admin/forms/${formId}`)
    .then(getData)
}

export const duplicateForm = (formId) => {
  return axios
    .post(`/admin/forms/duplicate/${formId}`)
    .then(getData)
}

// export const deleteCategory = async (id) => {
//   return axios.delete(`/admin/expense-categories/${id}`).then(getData);
// };

// export const postNewCategory = async (data) => {
//   return axios.post("/admin/expense-categories", data).then(getData);
// };